import { initMarketMap } from "../components/map/index";

$(function () {
  stickyDetectorMarketPage();
  initMarketMap();
});

function stickyDetectorMarketPage() {
  // $("#banner-alert").on("closed.bs.alert", function () {
  //   $("#wrap").removeClass("is-banner");
  // });

  //Sticky mobile nav map
  if ($(window).width() < 1024) {
    const stickyElm = document.querySelector(".view-locations");
    if (stickyElm) {
      //to check when element get's position sticky
      var observer = new IntersectionObserver(
        function (entries) {
          // no intersection
          if (entries[0].intersectionRatio === 0)
            stickyElm.classList.add("is-sticky");
          // fully intersects
          else if (entries[0].intersectionRatio === 1)
            stickyElm.classList.remove("is-sticky");
        },
        {
          threshold: [0, 1],
        }
      );

      observer.observe(document.querySelector(".sticky-detector"));
    }
  }
}
